<template>
  <div class="index">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../assets/images/index_icon1.png" alt="" />
        </div>
        <div>首页>保函查验</div>
      </div>
    </div>
    <div class="index_bg"></div>
    <div class="index_center">
      <div class="ins_center">
        <div class="pull-left">
          <img src="../assets/images/ins_img.png" alt="" />
        </div>
        <div class="pull-right">
          <div class="u-flex">
            <div>
              <el-input
                class="inlineInput"
                v-model="bianhao"
                placeholder="请输入保函编号"
              ></el-input>
            </div>
            <div>
              <el-button class="certbtn" type="primary" @click="queryBh()"
                >查询</el-button
              >
            </div>
          </div>

          <div class="ins_txt_box" v-if="detail.zbWjbh">
            申请单位：{{ detail.zbDwname }} <br />
            保函编号：{{ detail.zbWjbh }} <br />
            受益人：{{ detail.zbLixiren }} <br />
            项目名称：{{ detail.projectName }} <br />
            保函金额：{{ detail.bhMoney }}<br />
            截止时间：{{ detail.endDate }} <br />
            担保机构：{{ detail.danbao }}<br />
          </div>
        </div>
      </div>

      <div class="ins_tips">
        其他平台/渠道办理的保函，查询真伪可联系人工客服查验
      </div>
    </div>
  </div>
</template>

<script>
import { sesStorage } from "@/model/storage.js";
import Qs from "qs";
export default {
  name: "",
  components: {},
  data() {
    return {
      bianhao: "",
      detail: {},
    };
  },
  methods: {
    queryBh() {
      if (this.bianhao) {
        let data = {
          bianhao: this.bianhao,
        };
        this.$http
          .post("/front/order/search", Qs.stringify(data))
          .then((res) => {
            if (res.data.code == 0) {
              this.detail = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          });
      } else {
        this.$message({
          message: "请输入保函编号",
          type: "error",
          center: true,
        });
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.index {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }

  .index_bg {
    width: 100%;
    height: 400px;
    background: url("../assets/images/InspectionTop.png") center center
      no-repeat;
    background-size: cover;
  }

  .index_center {
    width: 1500px;
    background-color: #fff;
    margin: -140px auto 0 auto;
    overflow: hidden;
    .ins_center {
      width: 1188px;
      overflow: hidden;
      margin-left: 54px;
      margin-top: 86px;
    }
  }
  .inlineInput {
    & >>> .el-input__inner {
      width: 342px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 120px;
    margin-left: 20px;
  }
  .ins_txt_box {
    margin-top: 30px;
    width: 312px;
    font-size: 14px;
    line-height: 36px;
    margin-left: 94px;
  }
  .ins_tips {
    text-align: center;
    font-size: 14px;
    margin: 50px 0 30px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Inspection.vue